module.exports = __webpack_public_path__ + "static/media/buildings.4af8b226.svg";